module.exports = "<p>\n  product-locations works!\n</p>\n"